import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import { Parser } from 'html-to-react';
import Translations from './Translations';
import columnTypes from '../../components/cms/grid/columnTypes';
import ModelService from '../../services/translation.service';
import gc from '../../components/cms/gridComponents';

const htmlToComponents = new Parser().parse;

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>),
  },
  {
    name: 'count',
    title: 'FR',
    value: ({ item }) => (<Badge color={item.count > 1 ? "success" : "danger"}>{item.count > 1 ? (<i className="fa fa-plus" />) : (<i className="fa fa-minus" />)}</Badge>),
    filter: false,
  },
  {
    name: 'key',
    title: t('Key'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.key}</Link>),
  },
  {
    name: 'text',
    title: t('Text'),
    value: ({ item }) => htmlToComponents(item.text),
    className: '',
  },
  {
    name: 'namespace',
    title: t('Namespace'),
    value: ({ item }) => (<Badge color="primary">{ModelService.getNamespaceTitle(item.namespace, t)}</Badge>),
    filter: gc.selectFilter(ModelService.getNamespaceOptions(t)),
  },
  {
    name: 'is_html',
    title: t('Is HTML'),
    value: gc.checkBoxDataCell({ ModelService, t, attr: 'is_html' }),
    filter: gc.checkBoxFilter({ ModelService, t }),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const mapStateToProps = state => ({
  token: state.auth.token,
});

const enhance = compose(
  translate('core'),
  connect(mapStateToProps, null),
  defaultProps({
    getColumns,
    service: ModelService,
  }),
);

export default hoistStatics(enhance)(Translations);



// WEBPACK FOOTER //
// ./src/views/translates/index.js